import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface TournamentPlayerProfileTabProps {
  data: Record<string, any>;
}

export const TournamentPlayerProfileTab: React.FC<TournamentPlayerProfileTabProps> = ({ data }) => {
  const profile = data.player_profile || {};

  const formatDate = (dateString?: string) => {
    if (!dateString) return '—';
    try {
      return new Date(dateString).toLocaleString('ru-RU');
    } catch {
      return dateString;
    }
  };

  return (
    <div>
      <S.SectionTitle>Игровой профиль</S.SectionTitle>
      <S.InfoRow>
        <S.InfoLabel>UID</S.InfoLabel>
        <S.InfoValue>{profile.uid || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Игровое имя</S.InfoLabel>
        <S.InfoValue>{profile.username || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Рейтинг</S.InfoLabel>
        <S.InfoValue>{profile.rating || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Ранг</S.InfoLabel>
        <S.InfoValue>
          {profile.rank_display || profile.rank || '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Турнирный ранг</S.InfoLabel>
        <S.InfoValue>{profile.tournament_rank || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Основная роль</S.InfoLabel>
        <S.InfoValue>
          {profile.primary_role_display || profile.primary_role || '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Вторичная роль</S.InfoLabel>
        <S.InfoValue>
          {profile.secondary_role_display || profile.secondary_role || '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Twitch</S.InfoLabel>
        <S.InfoValue>
          {profile.twitch_username ? (
            <a href={`https://twitch.tv/${profile.twitch_username}`} target="_blank" rel="noopener noreferrer">
              {profile.twitch_username}
            </a>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Платформа</S.InfoLabel>
        <S.InfoValue>{profile.platform || '—'}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Tracker URL</S.InfoLabel>
        <S.InfoValue>
          {profile.tracker_url ? (
            <a href={profile.tracker_url} target="_blank" rel="noopener noreferrer">
              Открыть профиль
            </a>
          ) : '—'}
        </S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Создан</S.InfoLabel>
        <S.InfoValue>{formatDate(profile.created_at)}</S.InfoValue>
      </S.InfoRow>
      <S.InfoRow>
        <S.InfoLabel>Обновлен</S.InfoLabel>
        <S.InfoValue>{formatDate(profile.updated_at)}</S.InfoValue>
      </S.InfoRow>
    </div>
  );
};

